<template>
  <div class="intro-card card">
    <div v-if="!isTradePanel" class="title">
      {{ introTitle }}
    </div>
    <!-- US & HK Intro -->
    <div v-if="!isAStock || isEtf">
      <div v-if="isEtf">
        {{ companyIssuer }}
      </div>
      <div v-html="styledDescription" />
    </div>
    <!-- A Stock Intro -->
    <div v-if="isAStock">
      <div class="intro-item">
        {{ companyIntro.companyName }}
      </div>
      <div class="intro-item">
        <span>{{ $t('quote.brief.industry') }}：</span>
        <span>{{ companyIntro.boardName }}</span>
      </div>
      <div class="intro-item">
        <span>{{ $t('quote.brief.market-date') }}：</span>
        <span>{{ companyIntro.listingDate }}</span>
      </div>
      <div class="intro-item">
        <span>{{ $t('quote.brief.reg-address') }}：</span>
        <span>{{ companyIntro.address }}</span>
      </div>
      <div class="intro-item">
        <span>{{ $t('quote.brief.reg-cash') }}：</span>
        <span>{{ companyIntro.registeredCapital }}</span>
      </div>
      <div class="intro-item">
        <div>{{ $t('quote.brief.co-situation') }}：</div>
        <div>{{ companyIntro.survey }}</div>
      </div>
    </div>
    <div
      v-if="companyIntro.websiteUrl && (!isAStock || isEtf)"
      class="link-line"
    >
      {{ $t('quote.website') + '：' }}
      <a :href="companyIntro.websiteUrl" target="_blank" class="link">
        {{ companyIntro.websiteUrl }}
      </a>
    </div>
    <div
      v-if="companyIndustry && companyIndustry.length > 0"
      class="industry-card card"
    >
      <div class="sub-title">
        {{ industryCardTitle }}：
        <span
          v-for="(industry, index) in companyIndustry"
          :key="index"
          class="industry"
        >
          <label v-if="index !== 0">、</label>{{ industry[1] }}
        </span>
      </div>
    </div>
    <div v-if="exchange && !isAStock">
      <span>{{ $t('quote.brief.exchange') }} {{ exchange }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IntroCard',
  props: {
    isAStock: {
      type: Boolean,
      required: true
    },
    isEtf: {
      type: Boolean,
      required: true
    },
    companyIntro: {
      required: true
    },
    companyIndustry: {
      type: Array
    },
    isTradePanel: false,
    exchange: {
      type: String,
      default: ''
    }
  },
  computed: {
    companyIssuer() {
      return (
        this.$t('quote.brief.issuer') +
        ': ' +
        (this.companyIntro.issuer || '--')
      )
    },
    introTitle() {
      return this.isEtf
        ? this.$t('quote.brief.etf-intro')
        : this.$t('quote.brief.intro')
    },
    styledDescription() {
      if (this.isAStock || !this.companyIntro.description) {
        return ''
      }
      const newHtml = this.companyIntro.description.replace(
        /<p>/gi,
        '<p style="color:#838D9E; font-size:12px">'
      )
      const result = newHtml.replace(
        /\n/gi,
        '</p><p style="color:#838D9E; font-size:12px">'
      )
      return result
    },
    industryCardTitle() {
      return this.isHKStock || this.isAStock
        ? this.$t('quote.brief.intro-info')
        : this.$t('quote.brief.industry')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.intro-card {
  .title {
    color: var(--default-font-color);
    font-size: 14px;
    margin-bottom: 8px;
  }
  .description-text {
    font-size: 12px;
    color: @light-grey;
  }
  .intro-item {
    span:nth-child(1) {
      margin-right: 8px;
    }
    &:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }
  .link-line {
    margin-top: 8px;
  }
}
</style>
